var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.1336 15.266L14.8002 5.66602C14.0836 4.37435 13.0919 3.66602 12.0002 3.66602C10.9086 3.66602 9.91689 4.37435 9.20023 5.66602L3.86689 15.266C3.19189 16.491 3.11689 17.666 3.65856 18.591C4.20023 19.516 5.26689 20.0243 6.66689 20.0243H17.3336C18.7336 20.0243 19.8002 19.516 20.3419 18.591C20.8836 17.666 20.8086 16.4827 20.1336 15.266Z",
    fill: "#E87A16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.2917C11.6583 14.2917 11.375 14.0083 11.375 13.6667V9.5C11.375 9.15833 11.6583 8.875 12 8.875C12.3417 8.875 12.625 9.15833 12.625 9.5V13.6667C12.625 14.0083 12.3417 14.2917 12 14.2917Z",
    fill: "#E87A16"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 17.0008C11.9498 17.0008 11.8915 16.9924 11.8332 16.9841C11.7832 16.9758 11.7332 16.9591 11.6832 16.9341C11.6332 16.9174 11.5832 16.8924 11.5332 16.8591C11.4915 16.8258 11.4498 16.7924 11.4082 16.7591C11.2582 16.6008 11.1665 16.3841 11.1665 16.1674C11.1665 15.9508 11.2582 15.7341 11.4082 15.5758C11.4498 15.5424 11.4915 15.5091 11.5332 15.4758C11.5832 15.4424 11.6332 15.4174 11.6832 15.4008C11.7332 15.3758 11.7832 15.3591 11.8332 15.3508C11.9415 15.3258 12.0582 15.3258 12.1582 15.3508C12.2165 15.3591 12.2665 15.3758 12.3165 15.4008C12.3665 15.4174 12.4165 15.4424 12.4665 15.4758C12.5082 15.5091 12.5498 15.5424 12.5915 15.5758C12.7415 15.7341 12.8332 15.9508 12.8332 16.1674C12.8332 16.3841 12.7415 16.6008 12.5915 16.7591C12.5498 16.7924 12.5082 16.8258 12.4665 16.8591C12.4165 16.8924 12.3665 16.9174 12.3165 16.9341C12.2665 16.9591 12.2165 16.9758 12.1582 16.9841C12.1082 16.9924 12.0498 17.0008 11.9998 17.0008Z",
    fill: "#E87A16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.520d98b38ac8d53f0ce6f996a22aff7d.svg";
export { ForwardRef as ReactComponent };